module.exports = __webpack_public_path__ + "static/media/metro11.f16639f1.png";